import { z } from 'zod';
export const emailTemplateDetailsGuard = z.object({
    subject: z.string(),
    content: z.string(),
    contentType: z.union([z.literal('text/html'), z.literal('text/plain')]).optional(),
    replyTo: z.string().optional(),
    sendFrom: z.string().optional(),
});
